import React, { useState } from 'react';
import InputForm from './components/InputForm';
import BaziResult from './components/BaziResult';
import './App.css';

function App() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  return (
    <div className="app">
      <header className="app-header">
        <h2>✦ 新派命理八字排盘 ✦</h2>
      </header>
      <main className="app-main">
        <InputForm setResult={setResult} setLoading={setLoading} />
        {loading && (
          <div className="loading-mask">
            <div className="loading-spinner" />
            <span>排盘中...</span>
          </div>
        )}
        {result && !loading && <BaziResult result={result} />}
      </main>
    </div>
  );
}

export default App;
